import { Routes } from '@angular/router';
import { AuthGuard } from '@cavo-admin/auth';
import { AppComponent } from './app.component';
import { CallbackComponent } from './callback/callback.component';
import { BlockedComponent } from './error/blocked.component';
import { DOCUMENTFLOW_JOBS_CONFIG } from './jobs/documentflow-jobs.config';
import { INGEST_JOBS_CONFIG } from './jobs/ingest-jobs.config';
import { LoginComponent } from './login.component';
import { LogoutComponent } from './logout/logout.component';
import { ProfileComponent } from './profile/profile.component';

export const APP_ROUTES: Routes = [
	{ path: 'login', component: LoginComponent },
	{ path: 'logout', component: LogoutComponent },
	{ path: 'callback', component: CallbackComponent },
	{ path: 'blocked', component: BlockedComponent },
	{
		path: '',
		component: AppComponent,
		children: [
			{ path: 'profile', component: ProfileComponent, data: { section: 'Profile' }, canActivate: [AuthGuard] },
			{
				path: 'home',
				loadChildren: () => import('./home/home.routes').then(m => m.HOME_ROUTES),
				data: { section: 'Instances' },
				canActivate: [AuthGuard],
			},
			{
				path: 'jobs/ingest',
				loadComponent: () => import('./jobs/jobs.component').then(m => m.JobsComponent),
				data: { config: INGEST_JOBS_CONFIG, section: 'Ingest Jobs' },
				canActivate: [AuthGuard],
			},
			{
				path: 'queues',
				loadComponent: () => import('./queues/queues.component').then(m => m.QueuesComponent),
				data: { section: 'Queue Summary' },
				canActivate: [AuthGuard],
			},
			{
				path: 'jobs/documentflow',
				loadComponent: () => import('./jobs/jobs.component').then(m => m.JobsComponent),
				data: { config: DOCUMENTFLOW_JOBS_CONFIG, section: 'Document Flow Jobs' },
				canActivate: [AuthGuard],
			},
			{ path: '**', redirectTo: 'home' },
		],
	},
];
